import type { LineItemForm } from '../../../pages/Campaigns/Form/types';
import { ANALYTICS_PROPERTY_KEYS } from '../constants';
import type { AnalyticsEventProperties } from '../types';
import { hasAdvancedDeliveryControls } from '../utils/hasAdvancedDeliveryControls';
import { hasPremiumContentTargeting } from '../utils/hasPremiumContentTargeting';

export type CampaignBuilderContextProps = {
  politicalClassification?: string;
  industryVertical?: string;
  userRole?: string;
  formValues?: LineItemForm;
};

export const buildCampaignBuilderContextProps = ({
  politicalClassification,
  industryVertical,
  userRole,
  formValues,
}: CampaignBuilderContextProps): AnalyticsEventProperties => ({
  ...(politicalClassification ? { [ANALYTICS_PROPERTY_KEYS.POLITICAL_CLASSIFICATION]: politicalClassification } : {}),
  ...(industryVertical ? { [ANALYTICS_PROPERTY_KEYS.INDUSTRY_VERTICAL]: industryVertical } : {}),
  ...(userRole
    ? {
        [ANALYTICS_PROPERTY_KEYS.USER_ROLE]: userRole,
        [ANALYTICS_PROPERTY_KEYS.DCM_USER_ROLE]: userRole,
      }
    : {}),
  ...(formValues
    ? {
        [ANALYTICS_PROPERTY_KEYS.IS_PREEMPTIBLE]: formValues.isPreemptible ?? false,
        [ANALYTICS_PROPERTY_KEYS.HAS_ADVANCED_DELIVERY_CONTROLS]: hasAdvancedDeliveryControls(formValues),
        [ANALYTICS_PROPERTY_KEYS.HAS_PREMIUM_CONTENT_TARGETING]: hasPremiumContentTargeting(formValues),
      }
    : {}),
});
